import { Injectable } from '@angular/core';
import packageJson from '../../../../../package.json';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly version: string = packageJson.version;

  get formattedVersion(): string {
    return `v${this.version}`;
  }

  get isSnapshot(): boolean {
    return /[a-zA-Z]$/.test(this.version);
  }
}
